export default __webpack_public_path__ + "locales/help.ky.json";